export default "__VITE_ASSET__B6wQDD4h__"